import angular from 'angular';

import './task-form.styles.scss';

import TaskFormController from './task-form.controller';

export default angular.module('autoboard.taskForm', [])
  .controller('TaskFormController', TaskFormController)
  .name;
